// ? some metadata for analytics

import type { NavigationHookAfter } from 'vue-router';

export const afterEachNavigationGuard: NavigationHookAfter = (to, _from): void => {
  // ? qualtrics
  window.Q_curl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  if (to.meta.pageTitle && typeof window.dataLayer === 'object') {
    // ? google tag manager
    window.dataLayer.push({
      title: to.meta.pageTitle,
      timestamp: new Date().toUTCString(),
    });
  }

  // TODO: maybe add some Dynatrace tags
};
